import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

const learningFeatures = [
  {
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/WhyLearntube/Frame%20427321767.png",
    title: "Top 1% Content",
    description:
      "Curated from across the world. No more time wasted looking for the best learning material.",
    width: "w-[90%]",
    desktopWidth: "w-[90%]",
    marginTop: "mt-[-2.00px]",
  },
  {
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/WhyLearntube/Frame%20427321767%20(1).png",
    title: "Certified Learning",
    description:
      "Assessments & Certification for 2170+ micro-skills across 210+ in-demand skill domains.",
    width: "w-[92%]",
    desktopWidth: "w-[90%]",
    marginTop: "mt-[-68px]",
  },
  {
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/WhyLearntube/Frame%20427321767%20(2).png",
    title: "Get Paid to Learn",
    description:
      "Earn coins for learning & redeem \nthem for cash rewards & even \niPhones.",
    width: "w-[94%]",
    desktopWidth: "w-[90%]",
    marginTop: "mt-[-68px]",
  },
  {
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/WhyLearntube/Frame%20427321767%20(3).png",
    title: "Placement Support",
    description:
      "Interview preparation, portfolio & CV guidance and access to our network of 900+ employers.",
    width: "w-[96%]",
    desktopWidth: "w-[90%]",
    marginTop: "mt-[-68px]",
  },
  {
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/WhyLearntube/Frame%20427321767%20(4).png",
    title: "Industry Expert Led Workshops",
    description:
      "From Brands like Google and Facebook! Ask a doubt & get guaranteed \nresponses.",
    width: "w-[98%]",
    desktopWidth: "w-[90%]",
    marginTop: "mt-[-68px]",
  },
  {
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/WhyLearntube/Frame%20427321767%20(5).png",
    title: "Learn From WhatsApp",
    description:
      "Sign up and Learn On The Go And \nGet Certified Right Inside Your \nWhatsapp!",
    width: "w-full",
    desktopWidth: "w-[90%]",
    marginTop: "mt-[-68px]",
  },
];

const whyPickLearnTube = ['Courses' , 'Certifications' , 'Career Opprtunities']

export const WhyLearnTube = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

useEffect(() => {
  const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


  const handleCardClick = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className="relative mt-11 md:mt-[158px] max-w-[1064px] mx-auto  flex w-full flex-col md:flex-row-reverse md:justify-between items-start md:items-center gap-6 md:gap-16">
      <header className="relative flex w-full md:w-[436px] md:flex-shrink-0  flex-col items-center md:items-center gap-1">
        <div className="w-full text-center md:text-left w-full text-base md:text-[18px] font-normal leading-4  text-[#ffffff80] [font-family:'Inter',Helvetica]">
          Why Pick LearnTube?
        </div>

        <h2
          className="md:mt-2 relative flex items-center justify-center text-center md:text-left text-2xl md:text-[32px] md:font-bold font-semibold leading-[130%] tracking-[0] text-white [font-family:'Inter',Helvetica]"
          style={{
            background: "linear-gradient(to right, #FFFFFF 0%, #F7E394 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Get Personalised Learning To Super-Charge Your Career With:
        </h2>
        <div className="mt-2 w-full flex flex-row items-center justify-center md:flex-col md:items-start md:justify-start gap-4 md:px-0">
          {whyPickLearnTube?.map((item, index) => (
            <div key={index} className="flex items-center justify-start gap-1 md:gap-2">
              <FontAwesomeIcon icon={faCheck} className="text-[#2BBD13] text-[14px]" />
              <p className="text-white font-medium text-[12px] md:text-[14px] leading-none inline line-clamp-1">{item}</p>
            </div>
          ))} 
        </div>
      </header>

      <div className="relative flex w-full flex-col items-center md:items-start">
        {learningFeatures?.map((feature, index) => (
          <div
            key={index}
            onClick={() => handleCardClick(index)}
            className={`flex flex-col  ${
              feature.width
            } relative cursor-pointer items-start gap-2 overflow-hidden p-3 transition-all duration-500 ease-out  ${
              index === 0 ? "mt-[-2.00px]" : feature.marginTop
            } ${
              index === learningFeatures.length - 1
                ? "mb-[-2.00px] ml-[-2.00px] mr-[-2.00px] md:ml-0 md:mr-0 md:mb-0"
                : ""
            } ${
              expandedIndex === index ? "translate-y-[-60px]" : ""
            } rounded-xl border-t-2 border-[#406AFF] bg-[#406AFF]/10 shadow-[0px_-4px_20px_#0000004c] backdrop-blur-[7.5px] backdrop-brightness-[100%] [border-top-style:solid] [-webkit-backdrop-filter:blur(7.5px)_brightness(100%)]`}

            style={{
              transform: `
                ${isDesktop ? `translate(${index * 44}px, ${index * 0}px)` : 'translate(0, 0)'} 
                ${expandedIndex === index ? "translateY(-60px)" : ""}
              `,
              width: isDesktop ? `${316 + index * 8}px` : `${90 + index * 2}%`,
              zIndex: index * 50,
              willChange: 'backdrop-filter',
              WebkitBackdropFilter: 'blur(7.5px) brightness(100%)',
              backdropFilter: 'blur(7.5px) brightness(100%)',
            }}
          
          >
            <div className="relative inline-flex items-center gap-3">
              <img
                className="relative h-6 w-[26px]"
                alt={feature.title}
                src={feature.icon}
              />

              <h3 className="relative flex w-fit items-center justify-center whitespace-nowrap text-base font-semibold leading-4 tracking-[0] text-white [font-family:'Inter',Helvetica]">
                {feature.title}
              </h3>
            </div>

            <div className="relative flex w-full items-center md:items-start gap-2.5 py-0 pl-10 pr-6 md:pr-0">
              <p className="w-full relative mt-[-1.00px] flex items-center justify-center md:justify-start md:text-left whitespace-pre-line text-sm font-normal leading-[19.6px] tracking-[0] text-[#ffffffb2] [font-family:'Inter',Helvetica]">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
